import React, { useState, useEffect, useRef } from 'react';


const generateZalgo = (text) => {
  const zalgoChars = [
    '\u0300', '\u0301', '\u0302', '\u0303', '\u0304', '\u0305', '\u0306', '\u0307',
    '\u0308', '\u0309', '\u030A', '\u030B', '\u030C', '\u030D', '\u030E', '\u030F',
    '\u0310', '\u0311', '\u0312', '\u0313', '\u0314', '\u0315', '\u0316', '\u0317',
    '\u0318', '\u0319', '\u031A', '\u031B', '\u031C', '\u031D', '\u031E', '\u031F',
    '\u0320', '\u0321', '\u0322', '\u0323', '\u0324', '\u0325', '\u0326', '\u0327',
    '\u0328', '\u0329', '\u032A', '\u032B', '\u032C', '\u032D', '\u032E', '\u032F',
    '\u0330', '\u0331', '\u0332', '\u0333', '\u0334', '\u0335', '\u0336', '\u0337',
    '\u0338', '\u0339', '\u033A', '\u033B', '\u033C', '\u033D', '\u033E', '\u033F',
    '\u0340', '\u0341', '\u0342', '\u0343', '\u0344', '\u0345', '\u0346', '\u0347',
    '\u0348', '\u0349', '\u034A', '\u034B', '\u034C', '\u034D', '\u034E', '\u034F',
  ];

  const zalgoify = (text) => {
    return text.split('').map(char => {
      if (Math.random() > 0.1) {
        const numberOfZalgoChars = Math.floor(Math.random() * 10) + 7;
        const zalgo = Array.from({ length: numberOfZalgoChars }, () => zalgoChars[Math.floor(Math.random() * zalgoChars.length)]).join('');
        return char + zalgo;
      }
      return char;
    }).join('');
  };

  return zalgoify(text);
};

const calculateTextStats = (text) => {
  const charWithSpace = text.length;
  const charWithoutSpace = text.replace(/\s/g, '').length;
  const wordCount = text.trim() ? text.trim().split(/\s+/).length : 0;
  const paragraphCount = text.trim() ? text.split(/\n+/).length : 0;
  const sentenceCount = text.trim() ? text.split(/[.!?]+/).filter(Boolean).length : 0;

  return { charWithSpace, charWithoutSpace, wordCount, paragraphCount, sentenceCount };
};

const ZalgoGlitchGenerator = () => {
  const [inputText, setInputText] = useState('');
  const [zalgoText, setZalgoText] = useState('');
  const [textStats, setTextStats] = useState({
    charWithSpace: 0,
    charWithoutSpace: 0,
    wordCount: 0,
    paragraphCount: 0,
    sentenceCount: 0
  });
  const [previewSize, setPreviewSize] = useState(16);
  const [copyMessage, setCopyMessage] = useState('');
  const [downloadText, setDownloadText] = useState('');
  const [downloadWord, setDownloadWord] = useState('');
  const [autoConvert, setAutoConvert] = useState(false);

  const textAreaRef = useRef(null);

  const adjustHeight = () => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    if (autoConvert) {
      setZalgoText(generateZalgo(inputText));
    }
    setTextStats(calculateTextStats(inputText));
    adjustHeight();
  }, [inputText, autoConvert]);

  const handleInputChange = (e) => {
    setInputText(e.target.value);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(zalgoText).then(() => {
      setCopyMessage('Text copied to clipboard!');
      setTimeout(() => setCopyMessage(''), 3000);
    }).catch((err) => {
      console.error('Failed to copy text: ', err);
    });
  };

  // const downloadTextFile = () => {
  //   const blob = new Blob([zalgoText], { type: 'text/plain' });
  //   const link = document.createElement('a');
  //   link.href = URL.createObjectURL(blob);
  //   link.download = 'output.txt';
  //   link.click();
  //   setDownloadText('Downloaded Text File!');
  //   setTimeout(() => setDownloadText(''), 3000);
  // };

  // const downloadWordFile = () => {
  //   const doc = new Blob([`<html><body>${zalgoText}</body></html>`], { type: 'application/msword' });
  //   const link = document.createElement('a');
  //   link.href = URL.createObjectURL(doc);
  //   link.download = 'output.doc';
  //   link.click();
  //   setDownloadWord('Downloaded Word File!');
  //   setTimeout(() => setDownloadWord(''), 3000);
  // };

  const reset = () => {
    setInputText('');
    setZalgoText('');
    setTextStats({
      charWithSpace: 0,
      charWithoutSpace: 0,
      wordCount: 0,
      paragraphCount: 0,
      sentenceCount: 0
    });
    setPreviewSize(16);
  };

  const handlePreviewSizeChange = (e) => {
    setPreviewSize(e.target.value);
  };

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
      <h4>Input Text</h4>

      <div className="form-group">
        <textarea
          ref={textAreaRef}
          className="form-control mb-3"
          placeholder="Enter normal text here..."
          value={inputText}
          onChange={handleInputChange}
        />
      </div>

      <div className="text-stats mb-4">
        <p>
          Total Characters with Space: {textStats.charWithSpace} | Total Characters without Space: {textStats.charWithoutSpace} | Total Words: {textStats.wordCount}
        </p>
        <p>
          Total Paragraphs: {textStats.paragraphCount} | Total Sentences: {textStats.sentenceCount}
        </p>
        <button className="btn btn-danger" onClick={reset}>Clear</button>
        <div className="form-check form-switch mt-2">
          <input
            type="checkbox"
            checked={autoConvert}
            onChange={() => setAutoConvert(!autoConvert)}
            className="form-check-input"
            id="autoConvert"
          />
          <label className="form-check-label" htmlFor="autoConvert">Auto Convert</label>
        </div>
      </div>

      <div className="mb-4">
        {!autoConvert && (
          <button className="btn btn-primary" onClick={() => setZalgoText(generateZalgo(inputText))}>
            Convert
          </button>
        )}
      </div>

      <div className="preview-size mb-4">
        <label htmlFor="preview-size-slider">Preview Size</label>
        <input
          id="preview-size-slider"
          type="range"
          min="12"
          max="36"
          value={previewSize}
          onChange={handlePreviewSizeChange}
          className="form-range"
        />
      </div>

      <div className="headings">
        <h4>Output</h4>
        <div className="output-box">
          <textarea
            className="form-control mb-3"
            style={{ height: '10rem', fontSize: `${previewSize}px` }}
            readOnly
            value={zalgoText}
          />
        </div>
      </div>

      <div className="actions mt-3">
        <button className="btn btn-primary" onClick={copyToClipboard}>Copy to Clipboard</button>
        {copyMessage && <div className="alert alert-success mt-2">{copyMessage}</div>}
{/* 
        <button className="btn btn-primary" onClick={downloadTextFile}>Download Text File</button>
        {downloadText && <div className="alert alert-success mt-2">{downloadText}</div>}

        <button className="btn btn-primary " onClick={downloadWordFile}>Download Word File</button>
        {downloadWord && <div className="alert alert-success mt-2">{downloadWord}</div>} */}
      </div>
    </div>
  );
};

export default ZalgoGlitchGenerator;
